import ResultsFormatterBase from "../ResultsFormatterBase.js";

class CompositeResultsFormatter extends ResultsFormatterBase{
    constructor(...formatter) {
        super();
        this.formatters = [];

        for (let f = 0; f < formatter.length; f++) {
            this.register(formatter[f]);
        }
    }

    register(formatter) {
        if (!(formatter instanceof ResultsFormatterBase)) {
            throw new TypeError('formatter must be an instance inheriting from ResultsFormatterBase class');
        }

        this.formatters.push(formatter);
    }

    format(results) {
        for (let f = 0; f < this.formatters.length; f++) {
            results = this.formatters[f].format(results);
        }

        return results;
    }
}

export default CompositeResultsFormatter;